let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jSHqN")).then(() => parcelRequire('a176G'));